
<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  name: "network-analysis-costs-chart",

  props: [ 'series', 'totalCost', 'whatIfTotalCost' ],

  watch: {
    series: function() {
      this.render()
    }
  },

  computed: {
    showLegend() {
      return this.series.plotWhatIf || false
    },
    dataSets() {
      let sets = [{
        backgroundColor: [ '#88b4e0', '#88b4e0', '#88b4e0', '#88b4e0' ],
        //data: [ this.series.freightCost || 0, this.series.inventoryCost || 0, this.series.laborCost || 0, this.series.realEstateCost || 0 ],
        data: [ this.series.inboundFreightCost || 0, this.series.outboundFreightCost || 0, this.series.laborCost || 0, this.series.realEstateCost || 0 ],
        label: 'Total Actual Cost: ' + (this.totalCost || '?')
      }]

      if(this.series.plotWhatIf) {
        sets.push({
          backgroundColor: [ '#FABF00', '#FABF00', '#FABF00', '#FABF00' ],
          data: [ this.series.whatIfFreightCost || 0, this.series.whatIfInventoryCost || 0, this.series.whatIfLaborCost || 0, this.series.whatIfRealEstateCost || 0 ],
          label: 'Total What-If Cost: ' + (this.whatIfTotalCost || '?')
        })  
      }

    return sets
    }

  },

  mounted () {
    this.render()
  },

  methods: {
    render() {
      this.renderChart({
        //labels: ['Freight', 'Inventory', 'Labor', 'Lease'],
        labels: ['Inbound Freight', 'Outbound Freight', 'Labor', 'Lease'],
        datasets: this.dataSets
        }, {
          legend: {
            display: true //this.showLegend
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var percentageOfTotal = ''
                
                if(tooltipItem && data.datasets && data.datasets[tooltipItem.datasetIndex] && data.datasets[tooltipItem.datasetIndex].data){
                  let totals = data.datasets[tooltipItem.datasetIndex].data
                  let total  = totals.reduce((t, curr) => t + curr)
                  percentageOfTotal = ` (${(tooltipItem.yLabel / total * 100).toFixed(1)}%)`
                }

                return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                    return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c
                }) + percentageOfTotal
              }
            }
          },
          maintainAspectRatio: false,
          animation: {
            onComplete: function() {
              var ctx = this.chart.ctx;
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";
              var chart = this;
              var datasets = this.config.data.datasets;

              datasets.forEach(function (dataset, i) {
                if(i > 0) {
                  ctx.font = "70% Roboto";
                  ctx.fillStyle = "#222"
                  chart.getDatasetMeta(i).data.forEach(function (p, j) {
                    let deltaPercent = (100 - (datasets[i].data[j] / datasets[i-1].data[j] * 100)).toFixed(2) * -1
                    ctx.fillText(`${deltaPercent}%`, p._model.x, p._model.y - 5);
                  })
                }
              })
            },          
          },
          scales: {
            yAxes: [{
              stacked: false,
              ticks: {
                suggestedMin: 0,
                userCallback: function(value) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(',');
                  return `$${value}`
                }
              },
              scaleLabel: {
                display: true,
                labelString: 'Dollars',
                fontColor: '#999',
              }
            }],
            xAxes: [{
              stacked: false,
              scaleLabel: {
                display: true,
                labelString: 'Expense Categories',
                fontColor: '#999'
              }
            }]

          }
        }
      )      
    }
  }
}

</script>